<template>
<v-breadcrumbs :items="breadcrumbList" class="pb-0" v-if="breadcrumbList">
  <template slot="item" slot-scope="props">
	<a v-if="props.item.link !== undefined && props.item.link !== '' " :href="`/${props.item.link}`" :class="{'disabled': !!props.item.link}">{{ props.item.name.toUpperCase() }}</a>
	<a v-else class="disabled">{{ props.item.name.toUpperCase() }}</a>
  </template>
</v-breadcrumbs> 
</template>
<script>
  export default {
    data () {
      return {
		  breadcrumbList: []
      }
    },
	mounted () { this.updateList() },
	watch: { '$route' () { this.updateList() } },
	methods: {
		routeTo (pRouteTo) {
		  if (this.breadcrumbList[pRouteTo].link) this.$router.push(this.breadcrumbList[pRouteTo].link)
		},
		updateList () { this.breadcrumbList = this.$route.meta.breadcrumb }
	}
 }
 </script>


// WEBPACK FOOTER //
// src/components/Includes/Breadcrumbs.vue